import React, { useState } from 'react';
import { useAsyncDebounce } from 'react-table';

import SearchIcon from '../../assets/svgComponents/SearchIcon';

import styles from './GlobalFilter.module.scss';

const GlobalFilter = ({ placeholder, searchTerm, setSearchTerm }) => {
  const [value, setValue] = useState(searchTerm);

  const onChange = useAsyncDebounce((searchValue) => {
    setSearchTerm(searchValue || undefined);
  }, 500);

  return (
    <div className={styles.globalFilterContainer}>
      <div className="input-group">
        <span className="input-group-text" id="inputGroup-sizing-default">
          <SearchIcon />
        </span>
        <input
          type="text"
          className="form-control shadow-none"
          aria-label="Default"
          aria-describedby="inputGroup-sizing-default"
          value={value || ''}
          placeholder={placeholder}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
        />
      </div>
    </div>
  );
};

export default GlobalFilter;
